<div id="si-datepicker-{{id}}" class="si-datepicker {{styleClass}}" [class.disabled]="disabled"
     [class.invalid]="formModel.invalid && (formModel.dirty || formModel.formDirective?.submitted)"
     [class.readonly-input]="readonlyInput"
     [class.show-today-icon]="showTodayIcon">
  <div *ngIf="!hideLabel">
    <si-label [text]="text"
              [tooltipText]="tooltipText"
              [tooltipPosition]="tooltipPosition"
              [tooltipIcon]="tooltipIcon"
              [tooltipStyleClass]="tooltipStyleClass"
              [tooltipEscape]="tooltipEscape"
              [forceShowTooltipIcon]="forceShowTooltipIcon"
              (tooltipIconClick)="onClickTooltipIcon($event)"
              forId="si-datepicker_calendar-{{id}}"
    ></si-label>
  </div>
  <div class="d-flex">
    <div class="si-datepicker_previous d-flex align-items-center mr-2"
         *ngIf="previousNextMode">
      <i class="si-datepicker_previous_icon"
         [attr.aria-label]="'CORE_DATEPICKER_PREVIUS_MONTH' | translate"
         [class.disabled]="!isPreviousButtonAvailable"
         (click)="onClickPrevious()"
      ></i>
    </div>
    <div class="si-datepicker_calendar d-flex flex-grow-1" siProvideParentForm
         [class.open]="pCalendar.overlayVisible"
         [class.si-datepicker_calendar_no-clear]="!showClear">
      <p-calendar #pCalendar #formModel="ngModel"
                  inputId="si-datepicker_calendar-{{id}}"
                  [name]="name"
                  [placeholder]="disabled ? '' : placeholderTranslated"
                  [(ngModel)]="modelDate"
                  [disabled]="disabled"
                  [minDate]="minDate"
                  [maxDate]="maxDate"
                  [defaultDate]="defaultDate"
                  [firstDayOfWeek]="firstDayOfWeek"
                  [timeOnly]="timeOnly"
                  [showTime]="showTime"
                  [monthNavigator]="true"
                  [yearNavigator]="true"
                  [yearRange]="yearRange"
                  [view]="view"
                  [stepMinute]="stepMinute"
                  [showIcon]="!showTodayIcon"
                  [readonlyInput]="readonlyInput"
                  (onSelect)="onSelectDate($event)"
                  (onClose)="onCloseCalendar()"
                  (onInput)="onChangeInput($event)"
                  (onBlur)="onBlurInput($event)"
                  (onFocus)="onFocusInput()"
                  siValidation="{{rule}}"
                  [siValidationElement]="validationElement"
                  [siValidationExternalErrorText]="validationExternalErrorText"
      ></p-calendar>
      <si-validation-element #validationElement
                             [formModel]="formModel"
                             [showErrorText]="!showRuleErrorOutsideIcon"
                             (errorTextChange)="validationErrorText = $event"
                             class="si-datepicker_calendar_validation"
      ></si-validation-element>
    </div>
    <div class="si-datepicker_next d-flex align-items-center ml-2"
         *ngIf="previousNextMode">
      <i class="si-datepicker_next_icon"
         [attr.aria-label]="'CORE_DATEPICKER_NEXT_MONTH' | translate"
         [class.disabled]="!isNextButtonAvailable"
         (click)="onClickNext()"
      ></i>
    </div>
    <div class="d-flex align-items-center ml-2" *ngIf="showTodayIcon">
      <i class="icon-clock pointer"
         [attr.aria-label]="'CORE_DATEPICKER_TODAY' | translate"
         (click)="onClickToday()"
      ></i>
    </div>
    <div class="si-datepicker_today d-flex align-items-center ml-2" *ngIf="showToday">
      <button class="si-button pointer" (click)="onClickToday()">
        <span translate="CORE_DATEPICKER_TODAY"></span>
      </button>
    </div>
  </div>
  <div *ngIf="showRuleErrorOutsideIcon">
    <si-validation-error-text [text]="validationErrorText || validationExternalErrorText"
                              [formModel]="formModel"
    ></si-validation-error-text>
  </div>
</div>
